import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
function Termtwo() {
  useEffect(() => {
    document.title =
      "Syllabus Term-2 -  St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Academics</li>
          <li>Syllabus Term-2</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12">
              <h1 className="fw-bold">Syllabus – Term 2</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold"> Nursery</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Term-II-Syllabus-2025-Nursery.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold">LKG</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/TERM-II-SYLLABUS-2025-LKG.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold">Class - I</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/C-1-Term-2-Syllabus.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold">Class - II</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Class-2-term-2-syllabus.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold">Class - III</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Term-II-SYLLABUS-class-3.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold">Class - IV</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Class-4-Term-2 Syllabus.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold"> Class - V</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/CLASS-5-TERM-II-SYLLABUS.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold"> Class - VI</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/CLASS-6-TERM-II-SYLLABUS.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold"> Class - VII</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Class-7-TERM-II-syllabus.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold"> Class - VIII</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Class-8-TERM-II-syllabus.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold"> Class - IX</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Class-9-TERM-II-syllabus.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default Termtwo;
